import { DRAWER_COLLAPSED, FETCH_CONNECTED } from "../constants/actions.type";
import {
  SET_DRAWER_COLLAPSED,
  TOGGLE_DRAWER_COLLAPSED,
  SET_BREADCRUMB,
  SET_CONNECTED
} from "../constants/mutations.type";
import _ from "lodash";

const initialState = () => ({
  drawerCollapsed: true,
  breadcrumbs: [],
  connected: navigator.onLine
});

const states = initialState();

const getters = {
  drawerCollapsed(state) {
    return state.drawerCollapsed;
  },
  breadcrumbByType(state) {
    return type =>
      state.breadcrumbs.find(d => {
        return d.type === type;
      });
  },
  connected: state => state.connected,
  getBreadCrumbs(state) {
    return state.breadcrumbs;
  }
};

const actions = {
  [DRAWER_COLLAPSED](context) {
    context.commit(TOGGLE_DRAWER_COLLAPSED);
  },
  [FETCH_CONNECTED]({ commit }, payload) {
    commit(SET_CONNECTED, payload);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [SET_DRAWER_COLLAPSED](state, data) {
    state.drawerCollapsed = data;
  },
  [TOGGLE_DRAWER_COLLAPSED](state) {
    state.drawerCollapsed = !state.drawerCollapsed;
  },
  [SET_BREADCRUMB](state, data) {
    let breadcrumbs = _.cloneDeep(state.breadcrumbs);
    let breadcrumb = breadcrumbs.findIndex(d => d.type == data.type);
    if (breadcrumb < 0) {
      breadcrumbs.push(data);
    } else {
      breadcrumbs[breadcrumb] = data;
    }
    state.breadcrumbs = breadcrumbs;
  },
  [SET_CONNECTED](state, payload) {
    state.connected = payload;
  }
};

export default {
  // namespaced: true,
  state: states,
  getters,
  actions,
  mutations
};
